import React from 'react';

import { Container } from './styles';

const LoadingSpinner: React.FC = () => <Container />;

export default LoadingSpinner;
